<template>
  <div class="f-v f-ast">
    <donut-modal-sections-title :title="title" />
    <div class="f-as w-100p">
      <div class="fc-g1 w-0 m-r4">
        <donut-input-text
          v-model="message"
          class="message-input"
          :autogrow="true"
          :autocomplete="['variables', 'emoji', 'users', 'channels']"
          :textarea="true"
          :max-length="2500"
        />
        <div class="f m-tx2">
          <button class="inv flexed" @click="saveProgressAndMoveToGifModal">
            <i class="mi m-r">image</i>
            <span>Add GIF</span>
          </button>
          <button v-if="gifUrl" class="inv flexed m-l4" @click="removeGif">
            <i class="mi m-r">delete</i>
            <span>Remove GIF</span>
          </button>
        </div>
      </div>
      <bonus-milestone-configs-slack-preview :editable="true" :message="message" :gif-url="gifUrl" :milestone-type="milestoneType" class="fc-g1 w-0 m-l4" />
    </div>
    <donut-modal-sections-actions save-action="bonusMilestoneConfigs/updateMilestoneConfig" :save-args="saveArgs" />
  </div>
</template>

<script setup>
  import { ref, computed, onBeforeMount } from 'vue';
  import { useStore } from 'vuex';
  import useGifAttaching from 'composables/gif-attaching';

  const { state, commit } = useStore();

  const milestoneType = computed(() => state.modal.data.milestoneType);
  const title = computed(() => `Customize ${milestoneType.value} messages`);

  const message = ref(state.modal.data.message);
  const gifUrl = computed(() => state.modal.data.gifUrl);

  // Progress Loading/Saving
  // // The nature of the flow between several modals is that we change the existing "open modal" information to be that of the new modal.
  // // Accordingly, we want to keep track of changes made in _this_ modal such that we can go back and forth without losing changes.
  const progressKeys = () => ({ message, gifUrl });
  const { saveProgressAndMoveToGifModal } = useGifAttaching({ progressKeys });
  const removeGif = () => { commit('updateModalData', { gifUrl: null }); };

  const saveArgs = computed(() => ({
      type: milestoneType.value,
      params: { message: message.value, image_url: gifUrl.value },
    }));

  // Lifecycle Hooks
  onBeforeMount(() => {
    Donut.Args.otherVariables = ['Recipient'];
  });
</script>
